import * as React from "react"
import {
  type LayoutComponentType,
  type SourceAccountMetricConfig,
  type SourceAccountMetricSeriesData,
  useReadSourceAccountMetricLiveDataQuery,
} from "@digits-graphql/frontend/graphql-bearer"
import { useViewVersion } from "src/frontend/components/Shared/Contexts/useViewVersion"

interface SourceAccountMetricResponse {
  metrics?: SourceAccountMetricSeriesData[]
  loading: boolean
}

/**
 * Queries for layout live data.
 *
 */
export function useSourceAccountMetricLiveData(
  sourceAccountMetric: SourceAccountMetricConfig | undefined | null,
  type: LayoutComponentType,
  skip?: boolean
): SourceAccountMetricResponse {
  const viewId = useViewVersion()

  const { data, loading } = useReadSourceAccountMetricLiveDataQuery({
    variables: {
      viewId,
      config: {
        type,
        sourceAccountMetric,
      },
    },
    skip: skip || !viewId.viewVersion,
    // Stop batching this request to unblock all the other components
    context: { noBatch: true },
  })

  return React.useMemo(() => {
    const liveData = data?.liveComponentData

    // Resolves the component data union types to the portions we care about
    if (liveData?.__typename === "SourceAccountMetric") {
      const { metrics } = liveData
      return { metrics, loading }
    }
    return { loading }
  }, [data?.liveComponentData, loading])
}
